import { PermissionGuard } from '../../../components/auth/ProtectedRoute';
import MButton from '../../../components/inputs/yup/materialui/mButton';
import { Dialog, DialogContent, DialogTitle, Grid2 } from '@mui/material';
import { TipoFuncionalidad } from '../../../utils/enums';

interface IProps {
    idMutuo: number;
    esLiquidado: boolean;
    onClickDeshacer: () => void;
    onClickComprobante: () => void;
    isDesactivado?: boolean;
}

const FooterLiquidacion: React.FC<IProps> = ({ idMutuo, esLiquidado, onClickDeshacer, onClickComprobante, isDesactivado }) => {

    return (
        <Grid2 sx={{ mb: 2 }}>
            {
                esLiquidado ?
                    <Grid2 container spacing={3} size={10} sx={{ textAlign: "right", justifyContent: 'flex-end' }}>
                        <PermissionGuard permissions={[TipoFuncionalidad.Administrar_liquidacion]}>
                            <MButton
                                variant="contained"
                                color='error'
                                disabled={isDesactivado}
                                onClick={onClickDeshacer}
                            >
                                Deshacer Liquidacion
                            </MButton>
                        </PermissionGuard>
                        <MButton
                            variant="contained"
                            onClick={onClickComprobante}
                        >
                            Comprobante Liquidación
                        </MButton>
                    </Grid2>
                    : <Grid2 container spacing={3} size={10} sx={{ textAlign: "right", justifyContent: 'flex-end' }}>
                        <PermissionGuard permissions={[TipoFuncionalidad.Administrar_liquidacion]}>

                            <MButton
                                type='submit'
                                disabled={isDesactivado}
                                variant="contained"
                            >
                                Liquidar
                            </MButton>
                            </PermissionGuard>
                    </Grid2>
            }
        </Grid2>
    )

}

export default FooterLiquidacion;